// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stem-split-button_wrapper__nwnu4"};